import React from 'react'
import Videos from '../Videos';
import { useHistory } from 'react-router-dom'

const DBDA_MA = React.memo(() => {

    const history = useHistory();

    const nextRoute = () => {
        history.push('/question6')
    }

    const title = "MA-Mechanical ability";
    const url = "https://careers4me.in/videos/Mechanical_Ability.mp4";

    return (
        <Videos title={title} url={url} onPress={nextRoute} />
    )
});

export default DBDA_MA